import { Component, OnInit } from '@angular/core';
import { DatePipe, formatDate } from '@angular/common';
//import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators, NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
import { CourseService } from "../../services/course.service";
import { NgxSpinnerService } from "ngx-spinner";
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-course-create',
  templateUrl: './course-create.component.html',
  styleUrls: ['./course-create.component.scss']
})
export class CourseCreateComponent implements OnInit {
  pipe = new DatePipe('en-US');
  minDate = new Date();
  submitted = false;
  img:any='';
  statusError: any; tab: any = ''; Enddate: any; changePhoto: any = ''; closeResult = '';
  errorInfo: { isError: boolean, errorMsg: string } = { isError: false, errorMsg: '' }; page: any = '';
  data = {}; courseData = ""; imageSrc: any = ''; adminData: any; courseId: any = ''; type: any = ''; pro: any = '';
  constructor(private spinner: NgxSpinnerService, private authCourse: CourseService, private modalService: NgbModal, private route: ActivatedRoute, private router: Router) {
    if (localStorage.getItem('adminData') == '' || localStorage.getItem('adminData') == null) {
      this.router.navigateByUrl('/admin-login');
    }
  }
  courseForm = new FormGroup({
    course_id: new FormControl(''),
    course_name: new FormControl('', [Validators.required]),
    course_status: new FormControl(''),
    is_active: new FormControl('1'),
    course_desc: new FormControl('', Validators.required),
    end_date: new FormControl('', Validators.required),
    course_image: new FormControl(''),
  });
  get f() { return this.courseForm.controls; }
  ngOnInit(): void {
    this.adminData = JSON.parse(localStorage.getItem('adminData') || '[]');
    this.route.queryParams.subscribe(queryParams => {
      this.courseId = queryParams['Id'];
      this.tab = queryParams['tab'];
      this.type = queryParams['type'];
      this.pro = queryParams['pro'];
    });
    if (this.courseId != '' && this.courseId != null) {
      this.getCourseDetails(this.courseId);
    }
  }

  logout() {
    // localStorage.clear();
    localStorage.removeItem('adminLoginPass');
    localStorage.removeItem('adminData');
    this.router.navigate(['./admin-login']);
  }
  open(content: any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  
  // cancelCourse() {
  //   if (this.type == 'edit') {
  //     document.getElementById('CloseIds')?.click();
  //     this.router.navigate(['/courses']);
  //   }else if(this.type == 2){
  //     document.getElementById('CloseIds')?.click();
  //     this.router.navigate(['/courses'], { queryParams: { tab: 2 } });
  //   } else if (this.courseId != '' && this.courseId != null) {
  //     this.authCourse.deletesCourse(this.courseId).subscribe(
  //       (data) => {
  //         if (data.status == 200) {
  //           document.getElementById('CloseIds')?.click();
  //           this.router.navigate(['/courses']);
  //         } else {
  //         }
  //       },
  //       (error) => {
  //       },
  //     );
  //   } else {
  //     document.getElementById('CloseIds')?.click();
  //     this.router.navigate(['/courses']);
  //   }
  // }
  cancelCourse() {
    if (this.type == 'edit') {
      document.getElementById('CloseIds')?.click();
      this.router.navigate(['/courses']);
    }else if(this.tab == 2){
      document.getElementById('CloseIds')?.click();
      this.router.navigate(['/courses'], { queryParams: { tab: 2 } });
    } else {
      document.getElementById('CloseIds')?.click();
      this.router.navigate(['/courses']);
    }
  }

  getCourseDetails(courseId: any) {
    this.spinner.show();
    this.authCourse.CourseDetail(courseId).subscribe(
      data => {
        if (data.courseData.course_image) {
          this.imageSrc = data.courseData.course_image;
        }
        let dates = this.pipe.transform(data.courseData.end_date, 'YYYY-MM-dd');
        data.courseData.end_date = dates + "T" + formatDate(Date.now(), 'HH:mm:ss', 'en-US') + ".000Z";
        this.courseForm.patchValue(data.courseData);
        this.spinner.hide();
      }, error => {
        this.spinner.hide();
      }
    )
  }
  autoSave(){
   // this.createCourses('2',0);
  }
  /*******course create */
  createCourses(course_status: any, tabIndex: number) {
    this.submitted = true;
    this.statusError = tabIndex;
    
    if (this.courseForm.invalid) {
      if (tabIndex == 0) { return; }
    }
    const date1 = new Date(this.courseForm.value.end_date);
    date1.setDate(date1.getDate() + 1);
    this.courseForm.patchValue({ course_status: course_status });
    this.courseForm.patchValue({ end_date: date1 });
    this.courseForm.value['created_by'] = this.adminData.user_id;
    if (this.courseForm.value.course_id != '' && this.courseForm.value.course_id != null) { this.page = 'edit'; } else { this.page = 'create'; }
    //console.log(this.courseForm.value,date1)
    this.spinner.show();
    this.authCourse.createCourse(this.courseForm.value, course_status, this.page).subscribe(
      (data) => {
        // console.log(data);
        if (data.status == 201 || data.status == 200) {
          this.courseForm.patchValue({ course_id: data.course_id });
          if (tabIndex == 0) {
            this.spinner.hide();
            if (!this.type && !this.pro) {
              this.router.navigate(['/courses_add_modules'], { queryParams: { courseId: data.course_id } });
            } else if (this.pro) {
              this.router.navigate(['/courses_add_modules'], { queryParams: { courseId: data.course_id, pro: 'review' } });
            } else { this.router.navigate(['/courses_add_modules'], { queryParams: { courseId: data.course_id, type: 'edit' } }); }
          } else {
            this.spinner.hide();
            this.router.navigate(['/courses'], { queryParams: { tab: tabIndex } });
          }
          this.spinner.hide();
        } else {
          this.spinner.hide();
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'Something went wrong'
        }
      },
      (error) => {
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
      },
    );
  }
  onFileChange(event: any) {
    this.img='';
    this.changePhoto = event.target.files.item(0);
    var mimeType = this.changePhoto.type;
    if (mimeType.match(/image\/(png|jpeg|jpg)/) == null) {
      alert('Only png , jpeg , jpg file supported only');
      return;
    }
    if (this.changePhoto.size / 1024 > 1024) {
      alert('The maximum supported file sizes 1 MB ');
      return;
    }
    // this.img = new Image();
    // this.img.src = window.URL.createObjectURL(this.changePhoto);
    // alert(this.img.naturalWidth);
    //   alert(this.img.naturalHeight);
    //   if (this.img.naturalWidth > 70  || this.img.naturalHeight > 70 ) {
    //     alert('Height and Width must  70*70 to 120*120.');
    //     return;
    //   }

    var reader = new FileReader();
    reader.readAsDataURL(this.changePhoto);
    reader.onload = (_event) => {
      const img = new Image();
      img.src = reader.result as string;
      img.onload = (_event) => {
      const height = img.naturalHeight;
      const width = img.naturalWidth;
      console.log('Width and Height', width, height);
      if ((height < 70  || height > 120) || (width < 70  || width > 120) ) {
            alert('Height and Width must  70*70 to 120*120.');
            return;
          }
      
      this.imageSrc = reader.result;
      this.courseForm.patchValue({ course_image: this.imageSrc });
    };
    }
  }
}
